var blockSectionScrollSnap = document.querySelector('.featured-header.block-section--scroll-animation');

if (blockSectionScrollSnap) {
  var scrollSnapContainer = blockSectionScrollSnap.querySelector('.scroll-snap-container');
  
  function initAddAnimationDelay() {
    const wysiwygElements = scrollSnapContainer.querySelectorAll('.wysiwyg');

    wysiwygElements.forEach((wysiwyg) => {
      var datas = wysiwyg.dataset;
      let delay = 0;

      const h2AndPElements = wysiwyg.querySelectorAll('h2, p');

      h2AndPElements.forEach((element) => {
        element.classList.add(datas['animateIn'], datas['animateOut']);

        element.style.animationDelay = `${delay}s`;

        delay += parseFloat(datas['delay']);
      });
    });
  }

  initAddAnimationDelay();
}
